var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.26 2.5c.748-.001 1.495.03 2.24.095V4.82h-1.38c-.802 0-1.423.183-1.817.648-.378.447-.444 1.04-.444 1.582v2.77h3.452l-.331 2.56h-3.12v9.12h-2.68v-9.12H7.11V9.82h3.07V6.7c0-1.416.43-2.452 1.12-3.134.693-.684 1.7-1.066 2.96-1.066Z",
    stroke: "#fff"
  })));
};
export default SvgFacebook;